import * as React from "react";
import Skeleton from "react-loading-skeleton";
import { Col, Row } from "reactstrap";

const BiometricaCardLoader = () => {
  return (
    <Col xl="4" lg="6" md="12" sm="12" xs="12">
      <div className="info-card white-background biometricaCardLoader">
        <Row>
          <Col md="3" sm="3" xs="3" className="images-column">
            <div className="image-biometrica-background imageLoader">
              <Skeleton circle={true} height={70} width={70} />
            </div>
          </Col>
          <Col md="9" sm="9" xs="9">
            <Row>
              <div className="match-data">
                <div className="date">
                  <p>
                    <Skeleton width={250} height={12} />
                  </p>

                  <p>
                    <Skeleton width={250} height={12} />
                  </p>
                  <p>
                    <Skeleton width={250} height={12} />
                  </p>
                  <p>
                    <Skeleton width={250} height={12} />
                  </p>
                  <p>
                    <Skeleton width={250} height={12} />
                  </p>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="text-right" md="12" sm="12" xs="12">
            <span style={{ marginRight: "20px" }}>
              <Skeleton width={120} height={30} />
            </span>
            <Skeleton width={120} height={30} />
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default BiometricaCardLoader;
